export default {
  namespaced: true,
  state: {
    selected: {
      isNew: true,
      data: {}
    }
  },
  mutations: {
    select(state, { isNew, data }) {
      state.selected.isNew = isNew
      state.selected.data = data

      if (!data.EmployeeIdentityCards) {
        state.selected.data.EmployeeIdentityCards = []
      }
    },

    reset(state) {
      state.selected.isNew = false
      state.selected.data = {}
    },

    addEmployeeAccountCard(state, newAccountCard) {
      state.selected.data.EmployeeIdentityCards.push(newAccountCard)
    },

    deleteEmployeeAccountCard(state, index) {
      state.selected.data.EmployeeIdentityCards.splice(index, 1)
    }
  }
}